import { component } from 'picoapp';
import Drawer from 'utils/drawer';
import predictiveSearch from 'utils/predictive-search';
import focusInput from 'utils/focus-input';

export default component((node) => {
  document.body.appendChild(node);
  const drawer = Drawer(node);
  const triggers = [...document.querySelectorAll<HTMLElement>('[data-trigger="search-drawer"]')];
  const inputField: HTMLInputElement = node.querySelector('input[type="search"]');

  if (!drawer || !triggers.length) return;

  let isOpen = false;

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      drawer.toggle();
      isOpen = !isOpen;

      if (inputField && isOpen) focusInput(inputField);
    });
  });

  if (inputField) predictiveSearch(node, inputField);
});
